
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import type { Application } from '@/types/database.types';

interface PEOSwitchesProps {
  values: {
    open_to_peo_benefits: boolean;
    open_to_peo_workers_comp: boolean;
    open_to_peo_401k: boolean;
    open_to_peo_epli: boolean;
    open_to_peo_ancillary: boolean;
    open_to_peo_eap: boolean;
  };
  onToggle: (field: keyof Pick<Application, 
    'open_to_peo_benefits' | 
    'open_to_peo_workers_comp' | 
    'open_to_peo_401k' | 
    'open_to_peo_epli' |
    'open_to_peo_ancillary' |
    'open_to_peo_eap'
  >, value: boolean) => void;
}

export const PEOSwitches = ({ values, onToggle }: PEOSwitchesProps) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Label htmlFor="open_to_peo_benefits">
          Interest in starting or moving Employee Medical Benefits under a PEO?
        </Label>
        <Switch
          id="open_to_peo_benefits"
          checked={values.open_to_peo_benefits}
          onCheckedChange={(checked) => onToggle('open_to_peo_benefits', checked)}
        />
      </div>

      <div className="flex items-center justify-between">
        <Label htmlFor="open_to_peo_ancillary">
          Interest in starting or moving Employee Ancillary Benefits under a PEO?
        </Label>
        <Switch
          id="open_to_peo_ancillary"
          checked={values.open_to_peo_ancillary}
          onCheckedChange={(checked) => onToggle('open_to_peo_ancillary', checked)}
        />
      </div>

      <div className="flex items-center justify-between">
        <Label htmlFor="open_to_peo_eap">
          Interest in starting or moving Employee Assistance Program (EAP) under a PEO?
        </Label>
        <Switch
          id="open_to_peo_eap"
          checked={values.open_to_peo_eap}
          onCheckedChange={(checked) => onToggle('open_to_peo_eap', checked)}
        />
      </div>

      <div className="flex items-center justify-between">
        <Label htmlFor="open_to_peo_workers_comp">
          Interest in starting or moving Workers Comp under a PEO?
        </Label>
        <Switch
          id="open_to_peo_workers_comp"
          checked={values.open_to_peo_workers_comp}
          onCheckedChange={(checked) => onToggle('open_to_peo_workers_comp', checked)}
        />
      </div>

      <div className="flex items-center justify-between">
        <Label htmlFor="open_to_peo_epli">
          Interest in starting or moving EPLI under a PEO?
        </Label>
        <Switch
          id="open_to_peo_epli"
          checked={values.open_to_peo_epli}
          onCheckedChange={(checked) => onToggle('open_to_peo_epli', checked)}
        />
      </div>

      <div className="flex items-center justify-between">
        <Label htmlFor="open_to_peo_401k">
          Interest in starting or moving 401(k) under a PEO?
        </Label>
        <Switch
          id="open_to_peo_401k"
          checked={values.open_to_peo_401k}
          onCheckedChange={(checked) => onToggle('open_to_peo_401k', checked)}
        />
      </div>
    </div>
  );
};
